import React from "react";
import { ShoppingCart, X, Plus } from "lucide-react";

const ItemCard = ({
  item,
  index,
  isPick5Filter,
  prices,
  isLoadingPrices,
  isInCart,
  onItemClick,
  onAddToCart,
  onRemoveFromCart,
  getItemQuantity
}) => {
  const handleAddToCart = (e) => {
    e.stopPropagation();
    onAddToCart({
      ...item,
      title: isPick5Filter ? `${item.title} Pick 5` : item.title,
      price: prices[item.id] || item.price,
    });
  };

  const handleRemoveFromCart = (e) => {
    e.stopPropagation();
    onRemoveFromCart(item.id);
  };

  const getPrice = () => {
    if (isPick5Filter) return " 5 for $250.00";
    if (isLoadingPrices) return "Loading...";
    return `$${prices[item.id] || item.price}`;
  };

  const quantity = getItemQuantity(item.id) || 0;

  return (
    <div
      className="item-card"
      onClick={() => onItemClick(item)}
      style={{ "--index": index }}
    >
      <div className="item-image">
        <img
          src={item.images[0]}
          alt={item.title}
          onError={(e) => (e.target.src = "/img/datlogoA.png")}
        />
      </div>
      <div className="item-info">
        <h3>{item.title}</h3>
        <p className="price">{getPrice()}</p>
        {quantity > 0 ? (
          <div className="cart-controls">
            <button
              className="add-another-btn"
              onClick={handleAddToCart}
              title="Add another"
            >
              <Plus size={16} />
            </button>
            <span className="quantity-badge">{quantity}</span>
            <button
              className="remove-all-btn"
              onClick={handleRemoveFromCart}
              title="Remove all"
            >
              <X size={16} />
            </button>
          </div>
        ) : (
          <button
            className="add-to-cart-btn"
            onClick={handleAddToCart}
          >
            <ShoppingCart size={20} />{" "}
            {isPick5Filter ? "5 for $250.00" : "Add to Cart"}
          </button>
        )}
      </div>
    </div>
  );
};

export default ItemCard;
